export { default } from "./useLazyContentSettingsGroupsGet";
